import styled from "styled-components";

export default styled.p`
  position: relative;
  width: 100%;
  color: var(--carter-brand);
  font-size: smaller;
  font-weight: bold;
  font-style: italic;
  text-align: center;
`;
